import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConsumerSignupComponent } from '../landing-pages/consumer/consumer-signup/consumer-signup.component';
import { ContactUsComponent } from '../landing-pages/contact-us/contact-us.component';
import { CookiePloicyComponent } from '../landing-pages/cookie-ploicy/cookie-ploicy.component';
import { PrivacyPolicyComponent } from '../landing-pages/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from '../landing-pages/terms-and-conditions/terms-and-conditions.component';
import { SubscriptionListComponent } from '../user/subscription-list/subscription-list.component';
import { AlbumListComponent } from './album-list/album-list.component';
import { VideoDetailV2Component } from './video-detail-v2/video-detail-v2.component';
import { videoDetailVersionGuard } from 'src/app/core/guards/video-detail-version.guard';
import { GenerListComponent } from './gener-list/gener-list.component';
import { ICHomeComponent } from './ic-home/ic-home.component';
import { IcMainComponent } from './ic-main/ic-main.component';
import { PlaylistDetailsComponent } from './playlist-details/playlist-details.component';
import { PlaylistComponent } from './playlist/playlist.component';
import { IcSearchComponent } from './ic-search/ic-search.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { IcContactusComponent } from './ic-contactus/ic-contactus.component';
import { ChannelWebpageGuard } from 'src/app/core/guards/channel-webpage.guard';
import { MobileAppDownloadComponent } from "../landing-pages/consumer/mobile-app/mobile-app-download.component";
import { CommunityComponent } from './community/community/community.component';
import { CommunityMaincontentComponent } from './community/community-maincontent/community-maincontent.component';
import { ChannelDefaultPageComponent } from './community/channel-default-page/channel-default-page.component';
import { VideoPlayerPageComponent } from './video-player-page/video-player-page.component';
import { UserInfoGuard } from 'src/app/core/guards/user-info.guard';
import { MerchMarketComponent } from '../merche-marketplace/merch-market/merch-market.component';
import { NetworkMerchandiseComponent } from '../merche-marketplace/network-merchandise/network-merchandise.component';
import { ProductMarketplaceComponent } from '../merche-marketplace/product-marketplace/product-marketplace.component';
import { OverviewProductComponent } from '../merche-marketplace/overview-product/overview-product.component';
import { ProductShoppingcartComponent } from '../merche-marketplace/product-shoppingcart/product-shoppingcart.component';
import { ShippingProductComponent } from '../merche-marketplace/shipping-product/shipping-product.component';
import { EventMarketplaceComponent } from '../merche-marketplace/event-marketplace/event-marketplace.component';
import { EventDetailsComponent } from '../event-navigation/pages/event-details/event-details.component';
import { EventTicketsComponent } from '../event-navigation/pages/event-tickets/event-tickets.component';
import { EventScheduleComponent } from '../event-navigation/pages/event-schedule/event-schedule.component';
import { ExpoListComponent } from '../event-navigation/pages/expo/expo-list/expo-list.component';
import { ExpoDetailsComponent } from '../event-navigation/pages/expo/expo-details/expo-details.component';
import { ExpoStudioComponent } from '../event-navigation/pages/expo/expo-studio/expo-studio.component';
import { PrivateChatComponent } from '../event-navigation/pages/private-chat/private-chat.component';
import { ContactsComponent } from '../event-navigation/pages/contacts/contacts.component';
import { NetworkingListComponent } from '../event-navigation/pages/networking-list/networking-list.component';
import { NetworkRoomComponent } from '../event-navigation/pages/network-room/network-room.component';
import { NetworkAdminComponent } from '../event-navigation/pages/network-admin/network-admin.component';
import { ClaimTicketComponent } from '../landing-pages/consumer/claim-ticket/claim-ticket.component';
import { communityGuard } from 'src/app/core/guards/community.guard';
import { communityVersionGuard } from 'src/app/core/guards/community-version.guard';
import { CommunityV2Component } from './community-v2/community-v2.component';
import { CmChatComponent } from './community-v2/cm-chat/cm-chat.component';
import { FastMultichannelComponent } from './storm-player/storm-player.component';


const routes: Routes = [
  // --- ORG: merchandise ---
  {
        path: ":channelName/merchandise",
        component: IcMainComponent,
        data: { fromNetwork: true },
        canActivate: [UserInfoGuard],
        children: [
          { path: "market", component: MerchMarketComponent },
          { path: "stormcloud-video", component: FastMultichannelComponent },
          { path: "event", component: EventMarketplaceComponent },
          { path: "merch-list", component: NetworkMerchandiseComponent },
          { path: "merch-list/preview", component: NetworkMerchandiseComponent },
          { path: "merch-list/channel/:sub-channel/preview", component: NetworkMerchandiseComponent },
          { path: "product-marketplace/:collection_id", component: ProductMarketplaceComponent },
          { path: "overviewProduct/:product_id/:collection_id", component: OverviewProductComponent },
          { path: "product-cart/:cart_id", component: ProductShoppingcartComponent, canActivate: [AuthGuard] },
          { path: "product-shipping/:cart_id", component: ShippingProductComponent, canActivate: [UserInfoGuard] },
        ]
  },
  // --- GROUP: merchandise ---
  {
    path: ":channelName/:groupName/merchandise",
    component: IcMainComponent,
    data: { fromNetwork: true },
    canActivate: [UserInfoGuard],
    children: [
      { path: "market", component: MerchMarketComponent },
      { path: "stormcloud-video", component: FastMultichannelComponent },
      { path: "event", component: EventMarketplaceComponent },
      { path: "merch-list", component: NetworkMerchandiseComponent },
      { path: "merch-list/preview", component: NetworkMerchandiseComponent },
      { path: "merch-list/channel/:sub-channel/preview", component: NetworkMerchandiseComponent },
      { path: "product-marketplace/:collection_id", component: ProductMarketplaceComponent },
      { path: "overviewProduct/:product_id/:collection_id", component: OverviewProductComponent },
      { path: "product-cart/:cart_id", component: ProductShoppingcartComponent, canActivate: [AuthGuard] },
      { path: "product-shipping/:cart_id", component: ShippingProductComponent, canActivate: [UserInfoGuard] },
    ]
  },
  {
    path: "",
    component: IcMainComponent,
    children: [

      // ======================================================
      // ORG LEVEL — 1 segment
      // ======================================================
      {
        path: ":channelName",
        component: ICHomeComponent,
      },

      // ======================================================
      // ORG LEVEL — literal-keyword routes (2–4+ segments)
      // ======================================================
      {
        path: ":channelName/signin",
        component: ICHomeComponent,
        data: { showSignIn: true }
      },
      {
        path: ":channelName/channel/:sub-channel",
        component: ICHomeComponent,
      },
      {
        path: ":channelName/channelSearch",
        component: IcSearchComponent
      },
      {
        path: ":channelName/preview",
        component: ICHomeComponent
      },
      {
        path: ":channelName/channel/:subChannelName/preview",
        component: ICHomeComponent
      },
      {
        path: ":pName/subscription-list",
        component: SubscriptionListComponent
      },
      {
        path: ":pName/subscription-list/channel/:sub_channel_name",
        component: SubscriptionListComponent
      },
      {
        path: ":channelName/sign-up",
        component: ConsumerSignupComponent
      },
      {
        path: ":channelName/404",
        component: MobileAppDownloadComponent
      },
      {
        path: ":channelName/my-library",
        component: PlaylistComponent,
        canActivate: [AuthGuard]
      },
      {
        path: ":channelName/playlist/:id",
        component: PlaylistDetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: ":channelName/contactus",
        component: IcContactusComponent
      },
      {
        path: ":pName/subscription-list/preview",
        component: SubscriptionListComponent
      },
      {
        path: ":pName/subscription-list/channel/:sub-channel/preview",
        component: SubscriptionListComponent
      },
      {
        path: ":pName/privacypolicy",
        component: PrivacyPolicyComponent
      },
      {
        path: ":pName/cookiepolicy",
        component: CookiePloicyComponent
      },
      {
        path: ":pName/termsandconditions",
        component: TermsAndConditionsComponent
      },
      {
        path: ":pName/contactus",
        component: IcContactusComponent
      },

      // ======================================================
      // ORG LEVEL — album routes
      // ======================================================
      {
        path: ":channelName/album-video/:slug_name",
        component: VideoPlayerPageComponent
      },
      { path: ":channelName/album/:tag_category/:slug_name", component: VideoDetailV2Component, canMatch: [videoDetailVersionGuard], data: { heading: 'Album' } },
      {
        path: ":channelName/album/:tag_category/:slug_name",
        component: AlbumListComponent, data: { heading: 'Album' }
      },
      { path: ":channelName/album/channel/:tag_category/:slug_name", component: VideoDetailV2Component, canMatch: [videoDetailVersionGuard], data: { heading: 'Album' } },
      {
        path: ":channelName/album/channel/:tag_category/:slug_name",
        component: AlbumListComponent, data: { heading: 'Album' }
      },
      { path: ":channelName/album/:tag_category/:slug_name/preview", component: VideoDetailV2Component, canMatch: [videoDetailVersionGuard], data: { heading: 'Album' } },
      {
        path: ":channelName/album/:tag_category/:slug_name/preview",
        component: AlbumListComponent, data: { heading: 'Album' }
      },

      // ======================================================
      // ORG LEVEL — event routes (literal "event" at pos 2)
      // ======================================================
      {
        path: ":channelName/event",
        component: EventMarketplaceComponent,
        pathMatch: "full"
      },
      {
        path: ":channelName/event/preview",
        component: EventMarketplaceComponent,
        pathMatch: "full"
      },
      {
        path: ":channelName/event/channel/:sub-channel/preview",
        component: EventMarketplaceComponent,
        pathMatch: "full"
      },
      {
        path: ":channelName/event/home/:slug_name/:ticket_key",
        component: EventDetailsComponent,
      },
      {
        path: ":channelName/event/:slug_name/place-order",
        component: EventTicketsComponent
      },
      {
        path: ":channelName/event/:slug_name/place-order/:ticket_key",
        component: EventTicketsComponent
      },
      {
        path: ":channelName/event/schedule/:ticket_key",
        component: EventScheduleComponent
      },
      {
        path: ":channelName/event/expo-list/:ticket_key",
        component: ExpoListComponent,
      },
      {
        path: ":channelName/event/expo-details/:id/:ticket_key",
        component: ExpoDetailsComponent,
      },
      {
        path: ":channelName/event/expo-room/:room_token/:expo_id/:session_id/:ticket_key",
        component: ExpoStudioComponent,
      },
      {
        path: ":channelName/event/private-chat/:ticket_key",
        component: PrivateChatComponent,
      },
      {
        path: ":channelName/event/contacts/:ticket_key",
        component: ContactsComponent,
      },
      {
        path: ":channelName/event/networking-list/:ticket_key",
        component: NetworkingListComponent,
      },
      {
        path: ":channelName/event/networking-list/:ticket_key/:room_id",
        component: NetworkingListComponent,
      },
      {
        path: ":channelName/event/network-room/:room_id/:session_id/:ticket_key",
        component: NetworkRoomComponent,
      },
      {
        path: ":channelName/event/network-admin/:room_id/:session_id/:ticket_key",
        component: NetworkAdminComponent,
      },
      { path: ":channelName/event/claim-tickets/:ticket_key", component: ClaimTicketComponent },
      // dynamic :slug_name LAST in org event block
      {
        path: ":channelName/event/:slug_name",
        component: EventDetailsComponent,
      },

      // ======================================================
      // GROUP LEVEL — literal-keyword routes (before org all-dynamic)
      // ======================================================
      // Must be before :channelName/:groupName/preview to prevent "community" being matched as :groupName
      // v2 community page: matched only when communityVersionGuard picks it, else falls through to classic
      {
        path: ":channelName/community/preview",
        component: CommunityV2Component,
        canMatch: [communityVersionGuard],
        canActivate: [communityGuard],
        children: [
          { path: '', pathMatch: 'full', component: CmChatComponent }
        ]
      },
      {
        path: ":channelName/community/preview",
        component: CommunityComponent,
        canActivate: [communityGuard],
        children: [
          { path: '', pathMatch: 'full', component: CommunityMaincontentComponent }
        ]
      },
      { path: ":channelName/:groupName/signin", component: ICHomeComponent, data: { showSignIn: true } },
      { path: ":channelName/:groupName/channelSearch", component: IcSearchComponent },
      { path: ":channelName/:groupName/preview", component: ICHomeComponent },
      { path: ":channelName/:groupName/channel/:subChannelName/preview", component: ICHomeComponent },
      { path: ":channelName/:groupName/sign-up", component: ConsumerSignupComponent },
      { path: ":channelName/:groupName/404", component: MobileAppDownloadComponent },
      { path: ":channelName/:groupName/my-library", component: PlaylistComponent, canActivate: [AuthGuard] },
      { path: ":channelName/:groupName/playlist/:id", component: PlaylistDetailsComponent, canActivate: [AuthGuard] },
      { path: ":channelName/:groupName/contactus", component: IcContactusComponent },
      { path: ":channelName/:groupName/channel/:sub-channel", component: ICHomeComponent },

      // ======================================================
      // GROUP LEVEL — album routes (before org all-dynamic)
      // ======================================================
      { path: ":channelName/:groupName/album-video/:slug_name", component: VideoPlayerPageComponent },
      { path: ":channelName/:groupName/album/:tag_category/:slug_name", component: VideoDetailV2Component, canMatch: [videoDetailVersionGuard], data: { heading: 'Album' } },
      { path: ":channelName/:groupName/album/:tag_category/:slug_name", component: AlbumListComponent, data: { heading: 'Album' } },
      { path: ":channelName/:groupName/album/channel/:tag_category/:slug_name", component: VideoDetailV2Component, canMatch: [videoDetailVersionGuard], data: { heading: 'Album' } },
      { path: ":channelName/:groupName/album/channel/:tag_category/:slug_name", component: AlbumListComponent, data: { heading: 'Album' } },
      { path: ":channelName/:groupName/album/:tag_category/:slug_name/preview", component: VideoDetailV2Component, canMatch: [videoDetailVersionGuard], data: { heading: 'Album' } },
      { path: ":channelName/:groupName/album/:tag_category/:slug_name/preview", component: AlbumListComponent, data: { heading: 'Album' } },

      // ======================================================
      // GROUP LEVEL — event routes (literal "event" at pos 3, before org all-dynamic)
      // Literal sub-paths first, dynamic :slug_name last
      // ======================================================
      { path: ":channelName/:groupName/event", component: EventMarketplaceComponent, pathMatch: "full" },
      { path: ":channelName/:groupName/event/preview", component: EventMarketplaceComponent, pathMatch: "full" },
      { path: ":channelName/:groupName/event/channel/:sub-channel/preview", component: EventMarketplaceComponent, pathMatch: "full" },
      { path: ":channelName/:groupName/event/home/:slug_name/:ticket_key", component: EventDetailsComponent },
      { path: ":channelName/:groupName/event/:slug_name/place-order", component: EventTicketsComponent },
      { path: ":channelName/:groupName/event/:slug_name/place-order/:ticket_key", component: EventTicketsComponent },
      { path: ":channelName/:groupName/event/schedule/:ticket_key", component: EventScheduleComponent },
      { path: ":channelName/:groupName/event/expo-list/:ticket_key", component: ExpoListComponent },
      { path: ":channelName/:groupName/event/expo-details/:id/:ticket_key", component: ExpoDetailsComponent },
      { path: ":channelName/:groupName/event/expo-room/:room_token/:expo_id/:session_id/:ticket_key", component: ExpoStudioComponent },
      { path: ":channelName/:groupName/event/private-chat/:ticket_key", component: PrivateChatComponent },
      { path: ":channelName/:groupName/event/contacts/:ticket_key", component: ContactsComponent },
      { path: ":channelName/:groupName/event/networking-list/:ticket_key", component: NetworkingListComponent },
      { path: ":channelName/:groupName/event/networking-list/:ticket_key/:room_id", component: NetworkingListComponent },
      { path: ":channelName/:groupName/event/network-room/:room_id/:session_id/:ticket_key", component: NetworkRoomComponent },
      { path: ":channelName/:groupName/event/network-admin/:room_id/:session_id/:ticket_key", component: NetworkAdminComponent },
      { path: ":channelName/:groupName/event/claim-tickets/:ticket_key", component: ClaimTicketComponent },
      // dynamic :slug_name LAST in group event block
      { path: ":channelName/:groupName/event/:slug_name", component: EventDetailsComponent },

      // ======================================================
      // GROUP LEVEL — community (literal "community" at pos 3, before org all-dynamic)
      // ======================================================
      {
        path: ":channelName/:groupName/community",
        component: CommunityV2Component,
        canMatch: [communityVersionGuard],
        children: [
          { path: '', pathMatch: 'full', component: ChannelDefaultPageComponent },
          { path: ':channelId', component: CmChatComponent }
        ],
        canActivate: [communityGuard]
      },
      {
        path: ":channelName/:groupName/community",
        component: CommunityComponent,
        children: [
          { path: '', pathMatch: 'full', component: ChannelDefaultPageComponent },
          { path: ':channelId', component: CommunityMaincontentComponent }
        ],
        canActivate: [communityGuard]
      },

      // ======================================================
      // GROUP LEVEL — pName routes (literal keyword at pos 3)
      // Must be BEFORE org all-dynamic routes so that literal
      // "subscription-list" etc. win over the 4-wildcard pattern
      // ======================================================
      { path: ":pName/:groupName/subscription-list", component: SubscriptionListComponent },
      { path: ":pName/:groupName/subscription-list/channel/:sub_channel_name", component: SubscriptionListComponent },
      { path: ":pName/:groupName/subscription-list/preview", component: SubscriptionListComponent },
      { path: ":pName/:groupName/subscription-list/channel/:sub-channel/preview", component: SubscriptionListComponent },
      { path: ":pName/:groupName/privacypolicy", component: PrivacyPolicyComponent },
      { path: ":pName/:groupName/cookiepolicy", component: CookiePloicyComponent },
      { path: ":pName/:groupName/termsandconditions", component: TermsAndConditionsComponent },
      { path: ":pName/:groupName/contactus", component: IcContactusComponent },

      // ======================================================
      // USER DASHBOARD — channel-prefixed (must be before all-dynamic 4-segment routes)
      // ======================================================
      {
        path: ":channelName/user-dashboard",
        loadChildren: () => import("../user-dashboard/user-dashboard.module").then(m => m.UserDashboardModule),
        canActivate: [AuthGuard],
      },

      // ======================================================
      // ORG LEVEL — all-dynamic performer routes (4–7 segments)
      // Placed AFTER all group literal-keyword routes to avoid
      // the all-dynamic pattern swallowing group-level URLs
      // ======================================================
      {
        path: ":channelName/:tag_category/:tag_id/:performer_id",
        component: GenerListComponent
      },
      {
        path: ":channelName/channel/:tag_category/:tag_id/:performer_id/:sub-channel",
        component: GenerListComponent
      },
      {
        path: ":channelName/:tag_category/:tag_id/:performer_id/preview",
        component: GenerListComponent
      },
      {
        path: ":channelName/:tag_category/:tag_id/:performer_id/channel/:sub-channel/preview",
        component: GenerListComponent
      },

      // ======================================================
      // ORG LEVEL — community
      // ======================================================
      {
        path: ":channelName/community",
        component: CommunityV2Component,
        canMatch: [communityVersionGuard],
        children: [
          { path: '', pathMatch: 'full', component: ChannelDefaultPageComponent },
          { path: ':channelId', component: CmChatComponent }
        ],
        canActivate: [communityGuard]
      },
      {
        path: ":channelName/community",
        component: CommunityComponent,
        children: [
          { path: '', pathMatch: 'full', component: ChannelDefaultPageComponent },
          { path: ':channelId', component: CommunityMaincontentComponent }
        ],
        canActivate: [communityGuard]
      },
      {
        path: ":channelName/fastChannel",
        component: FastMultichannelComponent,
      },
      

      // ======================================================
      // GROUP LEVEL — all-dynamic performer routes (5–8 segments)
      // Different segment count from org 4-seg performer, so no
      // conflict; placed after org performer for clarity
      // ======================================================
      { path: ":channelName/:groupName/:tag_category/:tag_id/:performer_id", component: GenerListComponent },
      { path: ":channelName/:groupName/channel/:tag_category/:tag_id/:performer_id/:sub-channel", component: GenerListComponent },
      { path: ":channelName/:groupName/:tag_category/:tag_id/:performer_id/preview", component: GenerListComponent },
      { path: ":channelName/:groupName/:tag_category/:tag_id/:performer_id/channel/:sub-channel/preview", component: GenerListComponent },


      // ======================================================
      // MUST BE LAST — bare 2-segment group home (catches any
      // /:channelName/:groupName URL not matched above)
      // ======================================================
      { path: ":channelName/:groupName", component: ICHomeComponent },

    ],

  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IndigenousCloudRoutingModule { }
